import React from 'react';

const s = {
  section: {
    padding: '80px 0',
    background: '#080d20',
    borderTop: '1px solid rgba(255,255,255,0.05)',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
  },
  container: { maxWidth: 1100, margin: '0 auto', padding: '0 24px' },
  pillsRow: {
    display: 'flex', justifyContent: 'center', gap: 20,
    flexWrap: 'wrap', marginBottom: 48,
  },
  pill: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
    padding: '16px 28px',
    background: 'rgba(13,18,41,0.8)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 14, minWidth: 120,
  },
  pillIcon: { fontSize: 26, marginBottom: 2 },
  pillLabel: { fontSize: 11, color: '#8892b0', fontFamily: 'Sora, sans-serif', textTransform: 'uppercase', letterSpacing: 1 },
  headline: {
    textAlign: 'center',
    fontFamily: 'Sora, sans-serif', fontSize: 32, fontWeight: 800,
    marginBottom: 8,
  },
  sub: {
    textAlign: 'center', color: '#8892b0', fontSize: 15,
    fontFamily: 'DM Sans, sans-serif', marginBottom: 40,
  },
};

const pills = [
  { icon: '⚡', label: 'EFICIENCIA' },
  { icon: '👥', label: 'USUARIOS' },
  { icon: '🏛️', label: 'EMPRESAS' },
  { icon: '🔗', label: 'COLABORACIÓN' },
  { icon: '🛡️', label: 'SEGURIDAD' },
  { icon: '💬', label: 'USUARIAS' },
  { icon: '⚙️', label: 'PERMISOS' },
  { icon: '📉', label: 'REDUCCIÓN DE COSTOS' },
];

export default function SocialProof() {
  return (
    <section style={s.section}>
      <div style={s.container}>
        <div style={s.pillsRow}>
          
        </div>
        {/* <h2 style={s.headline}>Conecta todo tu equipo en un solo lugar</h2>
        <p style={s.sub}>Integración con las herramientas que ya utilizas en tu empresa.</p> */}
        <div style={{ marginTop: 80, borderRadius: 16, overflow: 'hidden', border: '1px solid #1F2D45', position: 'relative' }}>
          <img src="/assets/social-proof.png" alt="ArchiVex - Beneficios de gestión documental empresarial" style={{ width: '100%', height: 256, objectFit: 'cover' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(10,15,30,0.8), transparent, rgba(10,15,30,0.8))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', padding: 16 }}>
              <p style={{ fontSize: 24, fontWeight: 700, color: '#fff', marginBottom: 8 }}>Conecta todo tu equipo en un solo lugar</p>
              <p style={{ fontSize: 14, color: '#cfd5e7', fontFamily: 'DM Sans, sans-serif' }}>Integración con las herramientas que ya utilizas en tu empresa</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
